

exports.__esModule = true;
exports.$xoUpdatePinRoute = undefined;

var _index = require('squid/index');

var _directive = require('./directive');

var _directive2 = _interopRequireDefault(_directive);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var $xoUpdatePinRoute = exports.$xoUpdatePinRoute = _index.$Route.extend('$xoUpdatePinRoute', {
    path: 'updatePin',
    directive: _directive2['default'],
    children: []
});
exports['default'] = $xoUpdatePinRoute;

angular.value("$xoUpdatePinRoute", $xoUpdatePinRoute);
_index.$Route;


//////////////////
// WEBPACK FOOTER
// ../node_modules/xo-wallet-components/src/topup/update-pin/route.js
// module id = ../node_modules/xo-wallet-components/src/topup/update-pin/route.js
// module chunks = 0